module.exports = __webpack_public_path__ + "static/media/blog-7.5df1b130.svg";